import TPEAction from "src/models/common/TPEAction";
import { AccountingCalendarState } from "src/services/accounting-calendar/AccountingCalendarState";

export const ACTIONS = Object.freeze({
    GO_TO_NEXT_MONTH: new TPEAction('GO_TO_NEXT_MONTH'),
    GO_TO_PREV_MONTH: new TPEAction('GO_TO_PREV_MONTH'),
    SELECT_TAG: new TPEAction('SELECT_TAG'),
    CLEAR_SELECTED_TAG: new TPEAction('CLEAR_SELECTED_TAG'),
    OPEN_CREATE_FORM: new TPEAction('OPEN_CREATE_FORM'),
    OPEN_EDIT_FORM: new TPEAction('OPEN_EDIT_FORM'),
    CLOSE_FORM: new TPEAction('CLOSE_FORM'),
    OPEN_DELETE_DIALOG: new TPEAction('OPEN_DELETE_DIALOG'),
    CLOSE_DELETE_DIALOG: new TPEAction('CLOSE_DELETE_DIALOG'),
    BUMP_RELOAD: new TPEAction('BUMP_RELOAD'),
});

export function accountingCalendarReducer(state: AccountingCalendarState, action: TPEAction): AccountingCalendarState {
    switch (action.type) {
        case ACTIONS.GO_TO_NEXT_MONTH.type: {
            // Month 1-12; wrap within the viewed year (backend serves a single year).
            const next = state.viewMonth === 12 ? 12 : state.viewMonth + 1;
            return { ...state, viewMonth: next };
        }
        case ACTIONS.GO_TO_PREV_MONTH.type: {
            const prev = state.viewMonth === 1 ? 1 : state.viewMonth - 1;
            return { ...state, viewMonth: prev };
        }
        case ACTIONS.SELECT_TAG.type:
            return { ...state, selectedTag: action.payload };
        case ACTIONS.CLEAR_SELECTED_TAG.type:
            return { ...state, selectedTag: null };
        case ACTIONS.OPEN_CREATE_FORM.type:
            return { ...state, formMode: 'create', selectedTag: null };
        case ACTIONS.OPEN_EDIT_FORM.type:
            // payload = the tag to edit (defaults to the currently selected tag)
            return { ...state, formMode: 'edit', selectedTag: action.payload ?? state.selectedTag };
        case ACTIONS.CLOSE_FORM.type:
            return { ...state, formMode: 'closed' };
        case ACTIONS.OPEN_DELETE_DIALOG.type:
            return { ...state, deleteDialogOpen: true, selectedTag: action.payload ?? state.selectedTag };
        case ACTIONS.CLOSE_DELETE_DIALOG.type:
            return { ...state, deleteDialogOpen: false };
        case ACTIONS.BUMP_RELOAD.type:
            // Close any open overlays and force the calendar to re-fetch.
            return {
                ...state,
                reloadKey: state.reloadKey + 1,
                formMode: 'closed',
                deleteDialogOpen: false,
                selectedTag: null,
            };
        default:
            console.warn(`No action found for ${action.type}. Returning unchanged state`);
            return state;
    }
}
